import React from "react";
import { ListGroup } from "react-bootstrap";
import "./ListWithLogo.scss";
import Const from "const.json";
import ComparerIndicator from "../ComparerIndicator/ComparerIndicator";
import { SlArrowLeft } from "react-icons/sl";
import NavigationButton from "../NavigationButton/NavigationButton";
import { ActiveComponentEnum } from "enums/enums";
import { ListWithLogoProps } from "types/ListAndDetailTypes";
import Logo from "components/ui/Logo";
import { numberWithCommas } from "utils/utils";

const ListWithLogo: React.FC<ListWithLogoProps> = ({
  complaints,
  onNavigate,
  showIcon = false,
}) => {
  return (
    <ListGroup role="list">
      {complaints.map((item) => {
        const { description, complaintsCount, comparerData } = item;
        return (
          <ListGroup.Item key={item.id} className="list-design" role="listitem">
            <div className="d-flex justify-content-between">
              <div className="item-content">
                <div className="logo-container">
                  {showIcon && (
                    <Logo
                      className="logo-size"
                      alt={`${Const.logoOf + " " + item.description}`}
                      src={item.id}
                      defaultLogo={item.type}
                    />
                  )}
                </div>
                <div>
                  <span className="bold">
                    {description}
                  </span>
                </div>
              </div>
              <div className="item-left">
                <span className="bold">
                  {numberWithCommas(complaintsCount)} {Const.complaints}
                </span>
                <div>
                  <ComparerIndicator
                    comparerData={{
                      isDisplayPercent: comparerData.isDisplayPercent,
                      isIncrease: comparerData.isIncrease,
                      changeAmount: comparerData.changeAmount,
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="listGroupForExpansion">
              <NavigationButton
                navigateTo={ActiveComponentEnum.EntityDetails}
                text={Const.forExpansion}
                icon={<SlArrowLeft />}
                iconLabel={Const.leftIcon}
                additionalParams={item}
                onNavigate={onNavigate}
                ariaLabelText={description}
              />
            </div>
          </ListGroup.Item>
        );
      })}
    </ListGroup>
  );
};

export default ListWithLogo;
